import React from 'react';
import './style.scss';
import { identity } from "../../../utils/getIdentity";

const SwapNewCard = ({ title, children, className, buttonComponent }) => {
  return (
    <div className={`swap-new-card swap-new-card-${identity} ${className}`}>
      <div className="swap-new-card__header">
        <div className={`swap-new-card__title swap-new-card__title-${identity}`}>{title}</div>
        {buttonComponent}
      </div>
      {children}
    </div>
  );
};

export default SwapNewCard;
